<template>
	<div>
		<waiting v-if="loaded == false" />
		<AppVersionForm v-if="loaded" :item="item" @modifyItem="modifyItem"> </AppVersionForm>
	</div>
</template>

<script>
	export default {
		name: 'AppVersionManager',
		props: {},
		data: () => ({
			item: {},
			loaded: false,
		}),
		mounted: async function() {
			this.item = await this.$database.loadConfiguration('version');
			this.loaded = true;
		},
		methods: {
			async modifyItem(item) {
				await this.$database.setConfiguration('version', item);
				this.loaded = false;
				this.item = await this.$database.loadConfiguration('version');
				this.loaded = true;
			},
		},
	};
</script>

<style scoped></style>
